import type { CountriesRepository } from "../../domain/repositories/CountriesRepository";
import type { Country } from "../../domain/entities/Countries";

export const getCountries = async (
  repo: CountriesRepository,
): Promise<Country[]> => {
  return repo.getCountries();
};